module.exports = __webpack_public_path__ + "static/media/logo_Graine_NA.4fa35aae.png";